module.exports = __webpack_public_path__ + "static/YvonB-b6f86a0c1d8388988f60bcf13c7f5d9f.gif";